// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ultimate-security-settings-template .ultimate-security-notification .notification-menu {
  position: fixed;
  top: 32px;
  right: -100%;
  width: 100%;
  max-width: 570px;
  height: calc(100% - 32px);
  background: white;
  z-index: 1053;
  transform: translateX(100%);
  opacity: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: right 0.5s ease-in-out, transform 0.5s ease-in-out, opacity 0.5s ease-in-out;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu.initial {
  right: -100%;
  transform: translateX(100%);
  opacity: 0;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu.show {
  right: 0;
  transform: translateX(0);
  opacity: 1;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu.hide {
  right: -100%;
  transform: translateX(100%);
  opacity: 0;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu .notification-header {
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 20px;
  background-color: #5007aa;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu .notification-header span.title {
  color: #ffffff;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu .notification-header .close-icon {
  width: 24px;
  height: 24px;
  cursor: pointer;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu .histories {
  flex-grow: 1;
  overflow-y: auto;
  padding: 20px 30px;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu .histories::-webkit-scrollbar {
  width: 8px;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu .histories::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu .histories::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu .histories::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu .histories .history-unit {
  color: #000000;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  border-left: 1px solid #8185c9;
  padding-left: 24px;
  position: relative;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu .histories .history-unit .info {
  margin-bottom: 10px;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu .histories .history-unit .info .name {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu .histories .history-unit .info .name + .time-ago::before {
  content: "";
  display: inline-block;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #6bd2d1;
  margin-left: 10px;
  margin-right: 10px;
  vertical-align: middle;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu .histories .history-unit .info .time-ago {
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu .histories .history-unit:not(:last-child) {
  padding-bottom: 20px;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu .histories .history-unit::before {
  content: "";
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color: #8185c9;
  left: -9px;
  top: 0;
  display: block;
  position: absolute;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu .notification-actions {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  padding: 10px 20px;
  gap: 16px;
  width: 100%;
  border: 1px solid #d8d9db;
  background-color: #fffdee;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu .notification-description {
  font-family: "Figtree", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.14px;
  color: #000000;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu .cta-container {
  flex-shrink: 0;
  background-color: #d1c1ff;
  border: 1px solid #d8d9db;
  padding: 24px 30px;
  width: 100%;
  box-sizing: border-box;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu .cta-content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu .cta-text {
  display: flex;
  flex-direction: column;
  gap: 6px;
  max-width: 280px;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu .cta-text h3 {
  font-family: "Figtree", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.16px;
  color: #000000;
  margin: 0;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu .cta-text p {
  font-family: "Figtree", sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.14px;
  color: #000000;
  margin: 0;
}
.ultimate-security-settings-template .ultimate-security-notification .notification-menu .cta-button {
  background-color: #873eff;
  color: #ffffff;
  border: none;
  border-radius: 3px;
  padding: 8px 12px;
  font-family: "Figtree", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: 0.16px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
@media (max-width: 480px) {
  .ultimate-security-settings-template .ultimate-security-notification .notification-menu .notification-header {
    min-width: 100%;
  }
  .ultimate-security-settings-template .ultimate-security-notification .notification-menu .header-title,
  .ultimate-security-settings-template .ultimate-security-notification .notification-menu .header-tabs {
    padding: 10px;
  }
  .ultimate-security-settings-template .ultimate-security-notification .notification-menu .tab-group {
    flex-wrap: wrap;
  }
  .ultimate-security-settings-template .ultimate-security-notification .notification-menu .notification-actions {
    padding: 12px 16px;
  }
  .ultimate-security-settings-template .ultimate-security-notification .notification-menu .cta-container {
    padding: 16px 20px;
  }
  .ultimate-security-settings-template .ultimate-security-notification .notification-menu .cta-content {
    flex-direction: column;
    align-items: flex-start;
  }
  .ultimate-security-settings-template .ultimate-security-notification .notification-menu .cta-button {
    align-self: center;
    margin-top: 10px;
  }
}
.ultimate-security-settings-template .ultimate-security-notification .overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 1052;
  opacity: 0;
  transition: opacity 0.5s ease-in-out;
}
.ultimate-security-settings-template .ultimate-security-notification .overlay.show {
  opacity: 1;
}
.ultimate-security-settings-template .ultimate-security-notification .overlay.hide {
  opacity: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/Notifications/Notification.scss"],"names":[],"mappings":"AAEE;EACC,eAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,aAAA;EACA,2BAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,wFACC;AAFJ;AAOG;EACC,YAAA;EACA,2BAAA;EACA,UAAA;AALJ;AASG;EACC,QAAA;EACA,wBAAA;EACA,UAAA;AAPJ;AAWG;EACC,YAAA;EACA,2BAAA;EACA,UAAA;AATJ;AAYG;EACC,cAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;EACA,aAAA;EACA,yBAAA;AAVJ;AAYI;EACC,cAAA;AAVL;AAaI;EACC,WAAA;EACA,YAAA;EACA,eAAA;AAXL;AAeG;EACC,YAAA;EACA,gBAAA;EACA,kBAAA;AAbJ;AAgBI;EACC,UAAA;AAdL;AAiBI;EACC,mBAAA;AAfL;AAkBI;EACC,gBAAA;EACA,kBAAA;AAhBL;AAmBI;EACC,gBAAA;AAjBL;AAoBI;EACC,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;AAlBL;AAoBK;EACC,mBAAA;AAlBN;AAmBM;EACC,eAAA;EACA,gBAAA;EACA,iBAAA;AAjBP;AAoBQ;EACC,WAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;AAlBT;AAsBM;EACC,eAAA;EACA,gBAAA;EACA,iBAAA;AApBP;AAwBK;EACC,oBAAA;AAtBN;AAyBK;EACC,WAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,UAAA;EACA,MAAA;EACA,cAAA;EACA,kBAAA;AAvBN;AA4BG;EACC,cAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,yBAAA;EACA,yBAAA;AA1BJ;AA6BG;EACC,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;AA3BJ;AA8BG;EACC,cAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,WAAA;EACA,sBAAA;AA5BJ;AA+BG;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AA7BJ;AAgCG;EACC,aAAA;EACA,sBAAA;EACA,QAAA;EACA,gBAAA;AA9BJ;AAiCG;EACC,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,SAAA;AA/BJ;AAkCG;EACC,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,cAAA;EACA,SAAA;AAhCJ;AAmCG;EACC,yBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,kCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,sCAAA;AAjCJ;AAsCG;EACC;IACC,eAAA;EApCH;EAuCE;;IAEC,aAAA;EArCH;EAwCE;IACC,eAAA;EAtCH;EAyCE;IACC,kBAAA;EAvCH;EA0CE;IACC,kBAAA;EAxCH;EA2CE;IACC,sBAAA;IACA,uBAAA;EAzCH;EA4CE;IACC,kBAAA;IACA,gBAAA;EA1CH;AACF;AA8CE;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,UAAA;EACA,oCAAA;AA5CH;AA8CG;EACC,UAAA;AA5CJ;AA+CG;EACC,UAAA;AA7CJ","sourcesContent":[".ultimate-security-settings-template{\n\t.ultimate-security-notification {\n\t\t.notification-menu {\n\t\t\tposition: fixed;\n\t\t\ttop: 32px; // WordPress admin bar height\n\t\t\tright: -100%; // Start completely off-screen\n\t\t\twidth: 100%;\n\t\t\tmax-width: 570px;\n\t\t\theight: calc(100% - 32px); \n\t\t\tbackground: white;\n\t\t\tz-index: 1053;\n\t\t\ttransform: translateX(100%);\n\t\t\topacity: 0;\n\t\t\tbottom: 0;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\toverflow: hidden;\n\t\t\ttransition: \n\t\t\t\tright 0.5s ease-in-out, \n\t\t\t\ttransform 0.5s ease-in-out,\n\t\t\t\topacity 0.5s ease-in-out;\n\t\n\t\t\t// Initial state before showing\n\t\t\t&.initial {\n\t\t\t\tright: -100%;\n\t\t\t\ttransform: translateX(100%);\n\t\t\t\topacity: 0;\n\t\t\t}\n\t\n\t\t\t// Showing state\n\t\t\t&.show {\n\t\t\t\tright: 0;\n\t\t\t\ttransform: translateX(0);\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\n\t\t\t// Hiding state\n\t\t\t&.hide {\n\t\t\t\tright: -100%;\n\t\t\t\ttransform: translateX(100%);\n\t\t\t\topacity: 0;\n\t\t\t}\n\n\t\t\t.notification-header {\n\t\t\t\tflex-shrink: 0;\n\t\t\t\tdisplay: flex;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\twidth: 100%;\n\t\t\t\tpadding: 20px;\n\t\t\t\tbackground-color: #5007aa;\n\n\t\t\t\tspan.title {\n\t\t\t\t\tcolor: #ffffff;\n\t\t\t\t}\n\n\t\t\t\t.close-icon {\n\t\t\t\t\twidth: 24px;\n\t\t\t\t\theight: 24px;\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.histories {\n\t\t\t\tflex-grow: 1;\n\t\t\t\toverflow-y: auto;\n\t\t\t\tpadding: 20px 30px;\n\t\t\t\t\n\t\t\t\t// Customizing scrollbar (optional, but improves appearance)\n\t\t\t\t&::-webkit-scrollbar {\n\t\t\t\t\twidth: 8px;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t&::-webkit-scrollbar-track {\n\t\t\t\t\tbackground: #f1f1f1;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t&::-webkit-scrollbar-thumb {\n\t\t\t\t\tbackground: #888;\n\t\t\t\t\tborder-radius: 4px;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t&::-webkit-scrollbar-thumb:hover {\n\t\t\t\t\tbackground: #555;\n\t\t\t\t}\n\t\t\t\t\n\t\t\t\t.history-unit {\n\t\t\t\t\tcolor: #000000;\n\t\t\t\t\tfont-size: 14px;\n\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\tline-height: 20px;\n\t\t\t\t\tborder-left: 1px solid #8185c9;\n\t\t\t\t\tpadding-left: 24px;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\t\n\t\t\t\t\t.info {\n\t\t\t\t\t\tmargin-bottom: 10px;\n\t\t\t\t\t\t.name {\n\t\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\t\tline-height: 24px;\n\n\t\t\t\t\t\t\t+ .time-ago {\n\t\t\t\t\t\t\t\t&::before {\n\t\t\t\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\t\t\t\tdisplay: inline-block;\n\t\t\t\t\t\t\t\t\twidth: 4px;\n\t\t\t\t\t\t\t\t\theight: 4px;\n\t\t\t\t\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\t\t\t\t\tbackground-color: #6bd2d1;\n\t\t\t\t\t\t\t\t\tmargin-left: 10px;\n\t\t\t\t\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t\t\t\t\t\tvertical-align: middle;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t\t.time-ago {\n\t\t\t\t\t\t\tfont-size: 16px;\n\t\t\t\t\t\t\tfont-weight: 400;\n\t\t\t\t\t\t\tline-height: 24px;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t&:not(:last-child) {\n\t\t\t\t\t\tpadding-bottom: 20px;\n\t\t\t\t\t}\n\t\t\t\t\t\n\t\t\t\t\t&::before {\n\t\t\t\t\t\tcontent: \"\";\n\t\t\t\t\t\twidth: 18px;\n\t\t\t\t\t\theight: 18px;\n\t\t\t\t\t\tborder-radius: 50%;\n\t\t\t\t\t\tbackground-color: #8185c9;\n\t\t\t\t\t\tleft: -9px;\n\t\t\t\t\t\ttop: 0;\n\t\t\t\t\t\tdisplay: block;\n\t\t\t\t\t\tposition: absolute;\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.notification-actions {\n\t\t\t\tflex-shrink: 0;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tpadding: 10px 20px;\n\t\t\t\tgap: 16px;\n\t\t\t\twidth: 100%;\n\t\t\t\tborder: 1px solid #d8d9db;\n\t\t\t\tbackground-color: #fffdee;\n\t\t\t}\n\n\t\t\t.notification-description {\n\t\t\t\tfont-family: \"Figtree\", sans-serif;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tline-height: 20px;\n\t\t\t\tletter-spacing: 0.14px;\n\t\t\t\tcolor: #000000;\n\t\t\t}\n\n\t\t\t.cta-container {\n\t\t\t\tflex-shrink: 0;\n\t\t\t\tbackground-color: #d1c1ff;\n\t\t\t\tborder: 1px solid #d8d9db;\n\t\t\t\tpadding: 24px 30px;\n\t\t\t\twidth: 100%;\n\t\t\t\tbox-sizing: border-box;\n\t\t\t}\n\n\t\t\t.cta-content {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: row;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\talign-items: center;\n\t\t\t\tgap: 30px;\n\t\t\t}\n\n\t\t\t.cta-text {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: column;\n\t\t\t\tgap: 6px;\n\t\t\t\tmax-width: 280px;\n\t\t\t}\n\n\t\t\t.cta-text h3 {\n\t\t\t\tfont-family: \"Figtree\", sans-serif;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tline-height: 24px;\n\t\t\t\tletter-spacing: 0.16px;\n\t\t\t\tcolor: #000000;\n\t\t\t\tmargin: 0;\n\t\t\t}\n\n\t\t\t.cta-text p {\n\t\t\t\tfont-family: \"Figtree\", sans-serif;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tfont-weight: 400;\n\t\t\t\tline-height: 20px;\n\t\t\t\tletter-spacing: 0.14px;\n\t\t\t\tcolor: #000000;\n\t\t\t\tmargin: 0;\n\t\t\t}\n\n\t\t\t.cta-button {\n\t\t\t\tbackground-color: #873eff;\n\t\t\t\tcolor: #ffffff;\n\t\t\t\tborder: none;\n\t\t\t\tborder-radius: 3px;\n\t\t\t\tpadding: 8px 12px;\n\t\t\t\tfont-family: \"Figtree\", sans-serif;\n\t\t\t\tfont-size: 16px;\n\t\t\t\tfont-weight: 600;\n\t\t\t\tline-height: 24px;\n\t\t\t\tletter-spacing: 0.16px;\n\t\t\t\tcursor: pointer;\n\t\t\t\ttransition: background-color 0.2s ease;\n\t\t\t}\n\n\t\t\t\n\n\t\t\t@media (max-width: 480px) {\n\t\t\t\t.notification-header {\n\t\t\t\t\tmin-width: 100%;\n\t\t\t\t}\n\n\t\t\t\t.header-title,\n\t\t\t\t.header-tabs {\n\t\t\t\t\tpadding: 10px;\n\t\t\t\t}\n\n\t\t\t\t.tab-group {\n\t\t\t\t\tflex-wrap: wrap;\n\t\t\t\t}\n\n\t\t\t\t.notification-actions {\n\t\t\t\t\tpadding: 12px 16px;\n\t\t\t\t}\n\n\t\t\t\t.cta-container {\n\t\t\t\t\tpadding: 16px 20px;\n\t\t\t\t}\n\n\t\t\t\t.cta-content {\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\talign-items: flex-start;\n\t\t\t\t}\n\n\t\t\t\t.cta-button {\n\t\t\t\t\talign-self: center;\n\t\t\t\t\tmargin-top: 10px;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.overlay {\n\t\t\tposition: fixed;\n\t\t\ttop: 0;\n\t\t\tleft: 0;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tbackground: rgba(0,0,0,0.5);\n\t\t\tz-index: 1052;\n\t\t\topacity: 0;\n\t\t\ttransition: opacity 0.5s ease-in-out;\n\t\n\t\t\t&.show {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\n\t\t\t&.hide {\n\t\t\t\topacity: 0;\n\t\t\t}\n\t\t}\n\t}\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
